import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const kpiSettingListService = (params: Types.KPISettingListRequest) =>
  RestAPIClient.call<Types.KPISettingListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const kpiSettingMasterDataListService = (
  params?: Types.KPISettingListRequest
) =>
  RestAPIClient.call<Types.KPIMasterDataListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListMasterData,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const kpiSettingCreateBulkService = (
  params: Types.KPISettingCreateBulkRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.CreateBulk,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const kpiSettingUpdateService = (
  params: Types.KPISettingUpdateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const kpiSettingDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const kpiSettingDetailService = (id: string) =>
  RestAPIClient.call<Types.KPISetting>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
